module.exports = __webpack_public_path__ + "static/img_pledge_effect_03@2x-5d6799ab8194aa56645e3f9beca7fdb3.png";